export enum FeatureFlag {
  VAX_LOC_IDS = "VAX_LOC_IDS",
  GROWTH_CACHED_SLOTS_ENABLED = "GROWTH_CACHED_SLOTS_ENABLED",
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  PASSWORDLESS_WEB_SCHEDULING_ENABLED = "PASSWORDLESS_WEB_SCHEDULING_ENABLED",
  ENABLE_WEB_BOOKING_FOR_AUTHED_USERS = "ENABLE_WEB_BOOKING_FOR_AUTHED_USERS",
}
